import React from "react"

const PenIcon = ({ size }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{ width: size, height: size }}
			viewBox="0 0 22 22"
			fill="none"
		>
			<path
				d="M12 5L5.50182 6.29964C5.13883 6.37224 4.95733 6.40854 4.80952 6.4968C4.67886 6.57484 4.56772 6.68167 4.4846 6.80916C4.39057 6.95337 4.34714 7.13329 4.26028 7.49314L1 21M1 21L14.5069 17.7397C14.8667 17.6529 15.0466 17.6094 15.1908 17.5154C15.3183 17.4323 15.4252 17.3211 15.5032 17.1905C15.5915 17.0427 15.6278 16.8612 15.7004 16.4982L17 10M1 21L8.586 13.414M19.8686 6.86863L15.1314 2.13137C14.7354 1.73536 14.5373 1.53735 14.309 1.46316C14.1082 1.3979 13.8918 1.3979 13.691 1.46316C13.4627 1.53735 13.2646 1.73536 12.8686 2.13137L12.1314 2.86863C11.7354 3.26465 11.5373 3.46266 11.4632 3.69098C11.3979 3.89183 11.3979 4.10818 11.4632 4.30902C11.5373 4.53735 11.7354 4.73536 12.1314 5.13137L16.8686 9.86863C17.2646 10.2646 17.4627 10.4627 17.691 10.5368C17.8918 10.6021 18.1082 10.6021 18.309 10.5368C18.5373 10.4627 18.7354 10.2646 19.1314 9.86863L19.8686 9.13137C20.2646 8.73536 20.4627 8.53735 20.5368 8.30902C20.6021 8.10817 20.6021 7.89183 20.5368 7.69098C20.4627 7.46266 20.2646 7.26465 19.8686 6.86863ZM10 10C11.1046 10 12 10.8954 12 12C12 13.1046 11.1046 14 10 14C8.89543 14 8 13.1046 8 12C8 10.8954 8.89543 10 10 10Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default PenIcon
